export const LogoBase = () => {
    return (
        <div className="h-[70px] w-[70px] flex justify-center items-center">
            <img src="logo.png" className="h-[auto] ml-[0px]" alt="لوازم خانگی ماندگار - لوگو"/>
        </div>
    )
}
